import { render, staticRenderFns } from "./ProjectAssigns.vue?vue&type=template&id=42b628ac&"
import script from "./ProjectAssigns.vue?vue&type=script&lang=ts&"
export * from "./ProjectAssigns.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAssigns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports